// Única fuente de verdad para el menú lateral (SideBar de escritorio y NavDrawer móvil).
//
// - route:   nombre de la ruta a la que navega el ítem.
// - matches: otras rutas que deben marcar el ítem como activo (detalle, edición, etc.).
// - roles:   tipos de usuario que pueden ver el ítem (si no se indica, lo ven todos).
//            1 = acceso completo, 2 y 3 = acceso restringido (ver router/authMid.js).

export const navItems = [
  {
    text: "Dashboard",
    icon: "/icons/side-bar/dashboard.svg",
    route: "dashboard",
  },
  {
    text: "Client Management",
    icon: "/icons/side-bar/client-management.svg",
    route: "client-management",
    matches: ["create-new-client", "edit-client", "client-desc"],
    roles: [1],
  },
  {
    text: "Resource Management",
    icon: "/icons/side-bar/user-management.svg",
    route: "resource-management",
    matches: ["create-new-resource", "edit-resource"],
    roles: [1],
  },
  {
    text: "Project Management",
    icon: "/icons/side-bar/projects.svg",
    subItems: [
      {
        text: "Projects",
        icon: "/icons/side-bar/projects.svg",
        route: "projects",
        matches: ["create-new-project", "edit-project", "project-details"],
      },
      {
        text: "Timesheets",
        icon: "/icons/side-bar/timesheets.svg",
        route: "timesheets",
        matches: ["create-new-timesheet"],
        roles: [1, 2],
      },
      {
        text: "Invoices",
        icon: "/icons/side-bar/invoices.svg",
        route: "invoices",
        matches: ["create-new-invoice"],
        roles: [1],
      },
      {
        text: "Expenses",
        icon: "/icons/side-bar/expenses.svg",
        route: "expenses",
        matches: ["create-new-expense"],
      },
      {
        text: "Bills",
        icon: "/icons/side-bar/expenses.svg",
        route: "bills",
        roles: [1, 3],
      },
    ],
  },
  {
    text: "Reports",
    icon: "/icons/side-bar/reports.svg",
    route: "reports",
    matches: ["reports-filters", "reports-results"],
  },
  {
    text: "Account Settings",
    icon: "/icons/side-bar/settings.svg",
    route: "account-settings",
  },
];

const canSee = (item, role) => !item.roles || item.roles.includes(role);

// Devuelve el menú filtrado según el tipo de usuario. Sin rol no se muestra nada restringido.
export const getNavItemsForRole = (rawRole) => {
  const role = Number(rawRole) || null;
  return navItems
    .filter((item) => canSee(item, role))
    .map((item) =>
      item.subItems
        ? { ...item, subItems: item.subItems.filter((sub) => canSee(sub, role)) }
        : item
    )
    .filter((item) => !item.subItems || item.subItems.length > 0);
};

// true si `routeName` corresponde al ítem (su ruta o alguna de las relacionadas).
export const itemMatchesRoute = (item, routeName) =>
  !!routeName &&
  (item.route === routeName || (item.matches || []).includes(routeName));
